import type { ConversationNodeIVRMenu } from 'lib-shared-types-api';

type RoutedThroughIVRMenuProps = {
  node: ConversationNodeIVRMenu;
};

export function RoutedThroughIVRMenu({
  node,
}: RoutedThroughIVRMenuProps): JSX.Element {
  return (
    <>
      IVR ·{' '}
      {node.button ? (
        <>
          Pressed <strong>{node.button}</strong>
        </>
      ) : (
        'No response'
      )}
    </>
  );
}
